import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MUIDataTable from "mui-datatables";
import { API_URL } from "../../config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { pathSpliter, checkAuthBranchWare } from "../../lib/functions";
import {
  currentRouteSet,
  createdCustomerSet,
  updatedCustomerSet,
  disableRestoreCustomerSet,
} from "../../actions/actions";

import "react-responsive-modal/styles.css";

const ContactPersonsPerformance = ({
  location,
  currentRouteSet,
  authInfo,
  customerCodeAction,
  createdCustomer,
  updatedCustomer,
  customerDisableRestore,
  createdCustomerSet,
  updatedCustomerSet,
  disableRestoreCustomerSet,
  createdArea,
}) => {
  const classes = useStyles();
  let [loadingSave, loadingSaveSet] = useState(false);
  let [loadingList, loadingListSet] = useState(false);

  let [customers, customersSet] = useState([]);
  let [personPerformance, personPerformanceSet] = useState([]);

  let [employees, employeesSet] = useState([]);

  const [performanceSummary, performanceSummarySet] = useState([]);
  let [selectedContactPerson, selectedContactPersonSet] = useState(null);
  let [contactPersons, contactPersonsSet] = useState([]);

  let [selectedEmployee, selectedEmployeeSet] = useState(null);

  let customerNameRef = React.useRef(null);

  let customerActionRef = React.useRef(null);

  const [successMsg, setSuccessMsg] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
    msg: "",
  });

  const { vertical, horizontal, open, msg } = successMsg;
  const handleClose = () => {
    setSuccessMsg({ ...successMsg, open: false });
  };

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));

    getEmployees();
  }, []);

  const getEmployees = async () => {
    loadingListSet(true);
    await axios
      .post(`${API_URL}/api/get-customers`, null, {
        headers: { "auth-token": authInfo.token },
      })
      .then((res) => {
        loadingListSet(false);
        employeesSet(res.data.message);
      });
  };

  const getContactPersonPerformance = async () => {
    try {
      if (!selectedContactPerson) {
        console.error("No contact person selected!");
        return;
      }
      loadingListSet(true);

      const response = await axios.post(
        `${API_URL}/api/get-contact-person-performance`,
        {
          contactPersonId: selectedContactPerson.contact_person_id,
        },
        {
          headers: { "auth-token": authInfo.token },
        }
      );

      // Fetching return amounts
      const returnResponse = await axios.post(
        `${API_URL}/api/get-contact-person-return-amount`,
        { contactPersonId: selectedContactPerson.contact_person_id },
        {
          headers: { "auth-token": authInfo.token },
        }
      );
      const performanceData = response.data.data || [];
      const returnData = returnResponse.data.data || [];

      const combinedData = [...performanceData, ...returnData];

      const summary = combinedData.reduce((acc, item) => {
        const date = new Date(
          item.sale_created_isodt || item.sale_return_created_isodt
        ).toLocaleDateString();

        if (!acc[date]) {
          acc[date] = {
            date,
            totalSales: 0,
            totalDiscount: 0,
            totalPaid: 0,
            totalDue: 0,
            returnAmount: 0, // Initialize returnAmount here
          };
        }

        // Add sales data
        if (item.sale_total_amount) {
          acc[date].totalSales += item.sale_total_amount;
          acc[date].totalDiscount += item.sale_discount_amount;
          acc[date].totalPaid += item.sale_paid_amount;
          acc[date].totalDue += item.sale_due_amount;
        }

        // Add return data
        if (item.sale_return_amount) {
          acc[date].returnAmount += item.sale_return_amount;
        }

        return acc;
      }, {});

      performanceSummarySet(Object.values(summary));
    } catch (error) {
      console.error("Error fetching performance data:", error.message);
    } finally {
      loadingListSet(false);
    }
  };

  const columns = [
    { name: "date", label: "Date" },
    { name: "totalSales", label: "Total Sales" },
    { name: "totalDiscount", label: "Total Discount" },
    { name: "totalPaid", label: "Total Paid" },
    { name: "totalDue", label: "Total Due" },
    { name: "returnAmount", label: "Return Amount" },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    responsive: "standard",
  };

  let getContactPersons = async (id) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/get-contact-persons`,
        { customer_id: id }, // Pass id in the request body
        {
          headers: { "auth-token": authInfo.token },
        }
      );
      contactPersonsSet(response.data.message); // Update state with response data
    } catch (error) {
      console.error("Error fetching contact persons:", error);
    }
  };

  useEffect(() => {
    if (selectedEmployee) {
      getContactPersons(selectedEmployee.customer_id);
    }
  }, [selectedEmployee]);

  useEffect(() => {
    console.log("performanceSummary: ", performanceSummary);
  }, [performanceSummary]);

  console.log("performanceSummary: ", performanceSummary);

  return (
    <div className={classes.root}>
      {/* Success message */}
      <Snackbar open={open} autoHideDuration={10000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          {successMsg.msg}
        </Alert>
      </Snackbar>
      {/* End of message */}
      <Paper className={classes.paper} style={{ marginTop: "-15px" }}>
        <h2 className={classes.pageEntryLabel}>
          Sales Contact Person Performance
        </h2>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} className={classes.plusLinkDiv}>
            <Autocomplete
              style={{ width: "100%" }}
              options={employees}
              size="small"
              openOnFocus={true}
              getOptionLabel={(option) => option.customer_name}
              value={selectedEmployee}
              onChange={(event, selectedObj) => {
                selectedEmployeeSet(selectedObj);
              }}
              loading={employees.length == 0 ? true : false}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose a Customer"
                  variant="outlined"
                  inputProps={{
                    ...params.inputProps,
                    endAdornment: <React.Fragment></React.Fragment>,
                  }}
                />
              )}
            />
          </Grid>
          <Autocomplete
            autoHighlight={true}
            size="small"
            openOnFocus={true}
            style={{ width: "100%" }}
            options={contactPersons || []} // Use the data from the API
            value={selectedContactPerson}
            loading={false} // Set to true only if you're waiting for the API response
            onChange={async (e, customer) => {
              selectedContactPersonSet(customer); // Update the selected contact person
            }}
            getOptionLabel={(option) => option.contact_person_name || ""} // Correct the key
            renderInput={(params) => (
              <TextField
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    customerNameRef.current.focus();
                  }
                }}
                {...params}
                label="Choose a Contact Person"
                variant="outlined"
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            style={{ marginTop: "25px" }}
            variant="contained"
            color="primary"
            size="small"
            buttonRef={customerActionRef}
            className={classes.button}
            startIcon={<SaveIcon />}
            disabled={loadingSave}
            onClick={getContactPersonPerformance}
          >
            Submit
          </Button>
        </Grid>
      </Paper>
      {loadingList ? (
        <CircularProgress />
      ) : (
        <MUIDataTable
          title={"Contact Person Performance Summary"}
          data={performanceSummary}
          columns={columns}
          options={options}
        />
      )}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  root: {},
  "& .MuiTextField-root": {
    margin: theme.spacing(1),
    width: "25ch",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  pageEntryLabel: {
    color: "#7754cc",
    margin: "0px",
    padding: "0px",
    marginTop: "-11px",
    textAlign: "left",
    marginLeft: "0px",
    marginBottom: "5px",
    textAlign: "left",
  },
  fullWidth: {
    width: "100%",
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
  plusLinkDiv: {
    position: "relative",
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: "-21px",
    fontSize: "29px",
    height: "21px",
    textAlign: "right",
    position: "absolute",
    right: 0,
    color: "#3e8d54",
  },
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
    customerCode: state.customerCodeReducer,
    createdCustomer: state.createdCustomerReducer,
    updatedCustomer: state.updatedCustomerReducer,
    customerDisableRestore: state.customerDisableRestoreReducer,
    createdArea: state.createdAreaReducer,
  };
};
export default connect(mapStateToPops, {
  currentRouteSet,
  createdCustomerSet,
  updatedCustomerSet,
  disableRestoreCustomerSet,
})(ContactPersonsPerformance);
